import React, { useContext, useEffect, useState } from 'react';
import GlobalContext from '../../../contexts/GlobalContext';
import { Link } from "react-router-dom";
import Gmap from '../../Maps/Gmap';
import { Icon, Card, Image, Button, Grid, Item } from 'semantic-ui-react';
import Utility from '../../../Utility';
import './EstablishmentCard.css';

/**
 * Components EstablishmentV2
 * Widget pour le dashboard
 * @param {any} props.etab
 */
const EstablishmentV2 = props => {
  const [globalContext] = useContext(GlobalContext);
  const siteMap = Utility.getSiteMap(globalContext.translations);
  const [etabState, setEtabState] = useState(props.etab);
  //const [showMapState, setShowMapState] = useState(false);
  const [displayCardState, setDisplayCardState] = useState('flex');

    //const idEtab = Utility.getSiteMap(globalContext.translations);

  useEffect(() => {
      setEtabState( props.etab );
      //if( etabState?.display == false ){ setDisplayCardState('none')}
      //console.log( etabState?.display )
  }, [props.etab?.id, props.etab?.display])

  /*const toggleShowMap = () => {
    if (showMapState) {
      setShowMapState(false);
    }
    else{
      setShowMapState(true);
    }
  }*/

  /**
   * LIEN BE
   */

  let langIso = localStorage.getItem('lang');
  if (langIso === 'EN') {
    langIso = 'UK';
  }

  let filteredObjLang = {};
  if (globalContext?.languages !== undefined) {
    filteredObjLang = globalContext.languages.find(objLang => {
      return objLang.iso === langIso
    });
  }

  let langBe = Object.keys(filteredObjLang).length > 0 ? filteredObjLang.name : langIso;

  let linkBe = ``;
  let bookingEngineLinkProps = {};
  if( etabState?.customLinkBe != '' && typeof etabState?.customLinkBe !== "undefined" ){
    linkBe = `${etabState?.customLinkBe}`;
  }
  else{
    linkBe = Utility.getBookingEngineUrl(etabState?.bookingEngineId, langBe);
    bookingEngineLinkProps = Utility.getBookingEngineLinkProps(etabState?.bookingEngineId, linkBe);
  }

  /**
   * RETOUR HTML
   */
  return (

    <>
      <Item.Image 
        size='small' 
        src={etabState?.establishmentMainPhoto ?? ""} 
      />

      <Item.Content verticalAlign='middle'>
        <Item.Header>{etabState?.name}</Item.Header>
        <Item.Description>
          {/* Adresse */}
          {etabState?.firstAddress ? etabState?.firstAddress + "," : ""}
          {etabState?.zipCode ? etabState?.zipCode : ""} {etabState?.city ? etabState?.city : ""}  
          <br></br>
          <a href={`tel:${etabState?.telephoneCode}${etabState?.telephone}`}>
              <i aria-hidden="true" className="phone square icon blue" ></i>
            {etabState?.telephone ? etabState?.telephone : ""}
          </a> 
        </Item.Description>
        <Item.Extra>
          <Button
            as="a" target="_blank" href={linkBe} {...bookingEngineLinkProps}
            className="mt-2 showBe"
            content={globalContext.translations.addBooking}
            size='mini'
            color='green'
            /*compact*/
            icon='cart'
            labelPosition='left' 
            floated='right'
            /*fluid*/ />

        </Item.Extra>
      </Item.Content>

    </>
    /*<Card
        className='establishment'
        centered
      >
        <Card.Header style={{height:'200px'}}>
          { showMapState ?
            <Gmap lat={parseFloat(etabState?.latitude)} lng={parseFloat(etabState?.longitude)} zoom={13} establishment={etabState}/>
          : <Image 
              className="imageCard"
              src={etabState?.logo ?? ""} 
              ui={true}
            /> 
          }
          
        </Card.Header>
        <Card.Content>
          {/* Nom Etab }
          <Card.Header textAlign="center">{etabState?.name}</Card.Header>
          <Card.Description textAlign="center">
            <Grid >
              <Grid.Row columns={1}>
                <Grid.Column>
                  {/* Adresse }
                  {etabState?.firstAddress ? etabState?.firstAddress + "," : ""}
                  <br></br>
                  {etabState?.zipCode ? etabState?.zipCode : ""} {etabState?.city ? etabState?.city : ""}
                </Grid.Column>
              </Grid.Row>
            
              {/* Voir la map }
              {
                etabState?.latitude && etabState?.longitude ?
                <Grid.Row columns={1}>
                  <Grid.Column>
                    <Button
                      className="mt-2"
                      onClick={() => toggleShowMap()}
                      content={"voir la carte"}
                      size='mini'
                      compact
                      icon='map marker alternate'
                      labelPosition='left' 
                      fluid />
                  </Grid.Column>
                </Grid.Row>
                : ""
              }
              

              {/* Mailto et CallTo }
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Button
                    as="a" target="_blank" href={`tel:${etabState?.telephone}`}
                    className="mt-2"
                    content={"telephone"}
                    size='mini'
                    color='blue'
                    compact
                    icon='phone'
                    labelPosition='left'
                    fluid />
                </Grid.Column>
                <Grid.Column>
                  <Button
                    as="a" target="_blank" href={`mailto:${etabState?.mail}`}
                    className="mt-2"
                    content={"email"}
                    size='mini'
                    color='blue'
                    compact
                    icon='mail'
                    labelPosition='left'
                    fluid />
                </Grid.Column>
              </Grid.Row>

            </Grid>

          </Card.Description>
        </Card.Content>
        <Card.Content textAlign="right" extra >
          <Grid>
            {/* add booking }
            <Grid.Row columns={1}>
                  <Grid.Column>
                    <Button
                      as="a" target="_blank" href={linkBe}
                      className="mt-2"
                      content={globalContext.translations.addBooking}
                      size='mini'
                      color='green'
                      compact
                      icon='cart'
                      labelPosition='left' 
                      fluid />
                  </Grid.Column>
                </Grid.Row>
          </Grid>
        </Card.Content>
      </Card> */
  )
}

export default EstablishmentV2;

